import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const isDate = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === undefined || control.value === null) {
      return null;
    }
    try {
      new Date(control.value);
      return null;
    } catch {
      return { isNoDate: control.value };
    }
  };
};
